import { useDropboxChooser } from 'use-dropbox-chooser';
import { DROPBOX_APP_KEY } from '../../constants/constants';
import { ElipsisTooltip } from '../ElipsisTooltip';

export const DropBoxFilePicker = (props) => {
  if (!DROPBOX_APP_KEY) return null;

  return <DropBoxFilePickerUI {...props} />;
};

export const DropBoxFilePickerUI = ({ as, disabled, onSelect, extensions = '.zip', ...rest }) => {
  const { open, isOpen } = useDropboxChooser({
    appKey: DROPBOX_APP_KEY,
    chooserOptions: { multiple: true, linkType: 'direct', extensions, multiselect: true },
    onSelected: (files) => {
      if (!files.length) return;
      onSelect(files);
    },
  });

  const Component = as;

  return (
    <ElipsisTooltip title="Use dropbox" alwaysShow={true}>
      {(props) => <Component {...rest} onClick={open} disabled={disabled || isOpen} {...props} />}
    </ElipsisTooltip>
  );
};

export const DropBoxFilePickerButton = ({
  as,
  title = 'Choose from Dropbox',
  onSelect,
  ...rest
}) => {
  return (
    <DropBoxFilePicker as={as} onSelect={onSelect} {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="19"
        viewBox="25 24.999 850 790.592"
        style={{ marginRight: 8 }}>
        <g fill="#007ee5">
          <path d="M275.037 24.999L25 188.255l172.886 138.448L450 171.023zM25 465.16l250.037 163.256L450 482.374l-252.114-155.67zM450 482.374l174.963 146.042L875 465.16 702.114 326.703z" />
          <path d="M875 188.255L624.963 24.999 450 171.024l252.114 155.68zM450.513 513.797l-175.476 145.61-75.09-49.028v54.959L450.513 815.59 701.08 665.338v-54.96l-75.09 49.029z" />
        </g>
      </svg>
      {title}
    </DropBoxFilePicker>
  );
};